module.exports = __webpack_public_path__ + "media/images/writer/home/home-03-1b5d14e900cc756d745f548301a70292.png";